import React from "react";

interface PlusIconProps {
    width?: number;
    height?: number;
    color?: string;
}

const PlusIcon = ({ width = 20, height = 20, color = "white", ...props }: PlusIconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M4 9.99994H16M10 3.99994V15.9999"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default PlusIcon;
